import React, { useState, useRef, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { apiClient } from '../../components/api/ApiClient';

function ExcelUploadModal({ show, handleClose, branches, onSuccess }) {
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedBranch, setSelectedBranch] = useState('');
    const [isUploading, setIsUploading] = useState(false);
    const [uploadResult, setUploadResult] = useState(null);
    const [uploadError, setUploadError] = useState('');
    const fileInputRef = useRef(null);

    useEffect(() => {
        if (show && branches && branches.length > 0 && !selectedBranch) {
            setSelectedBranch(branches[0].taxMemoryId);
        }
    }, [show, branches]);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedFile(file);
            setUploadError('');
        }
    };

    const formatFileSize = (bytes) => {
        if (bytes < 1024) return bytes + ' بایت';
        const kb = (bytes / 1024).toFixed(2);
        return kb + ' کیلوبایت';
    };

    const handleUpload = async () => {
        if (!selectedFile) { setUploadError('لطفاً یک فایل اکسل انتخاب کنید.'); return; }
        if (!selectedBranch) { setUploadError('لطفاً یک شعبه انتخاب کنید.'); return; }

        setIsUploading(true);
        setUploadError('');
        setUploadResult(null);

        try {
            const formData = new FormData();
            formData.append('file', selectedFile);
            formData.append('branch', selectedBranch);

            const response = await apiClient('/invoice/api/new-invoice-excel/', {
                method: 'POST',
                data: formData,
                headers: { 'Content-Type': 'multipart/form-data' },
            });

            const data = response?.data || response;
            setUploadResult({
                success_count: data?.success_count || 0,
                success_invoices: data?.success_invoices || [],
                errors: data?.failed || data?.errors || [],
                partial: data?.partial || false,
            });
            if (onSuccess && !data.errors) onSuccess(response);

        } catch (error) {
            console.error('Excel upload error:', error);
            let responseData = null
            try {responseData = JSON.parse(error.message);} catch {responseData = error.message;}
            if (responseData && Array.isArray(responseData) && responseData.length > 0) {
                setUploadResult({
                    success_count: 0,
                    success_invoices: [],
                    errors: responseData,
                    partial: false,
                });
            } else {
                const rawMsg = responseData || error?.message || '';
                setUploadError(
                    rawMsg.length > 300
                        ? 'مشکلی پیش آمده است! لطفاً دوباره تلاش کنید.'
                        : rawMsg || 'خطا در آپلود فایل. لطفاً دوباره تلاش کنید.'
                );
            }
        } finally {
            setIsUploading(false);
        }
    };

    const resetAndClose = () => {
        setSelectedFile(null);
        setSelectedBranch('');
        setUploadError('');
        setUploadResult(null);
        setIsUploading(false);
        if (fileInputRef.current) fileInputRef.current.value = '';
        handleClose();
    };

    return (
        <Modal show={show} onHide={resetAndClose} centered size="md" scrollable>
            <Modal.Header closeButton>
                <Modal.Title>صدور فایل با اکسل</Modal.Title>
            </Modal.Header>
            <Modal.Body>

                {uploadError && (
                    <div className="alert alert-danger mb-3" style={{ whiteSpace: 'pre-line' }}>
                        {uploadError}
                    </div>
                )}

                {uploadResult && (
                    <div className="mb-3">
                        {/* {uploadResult.success_count > 0 && (
                            <div className="alert alert-success mb-2">
                                <div className="fw-bold mb-1">
                                    ✅ {uploadResult.success_count} صورتحساب با موفقیت صادر شد
                                </div>
                                {uploadResult.success_invoices.length > 0 && (
                                    <div style={{ fontSize: '0.85rem', marginTop: '4px' }}>
                                        {uploadResult.success_invoices.map((inv, i) => (
                                            <span key={i} className="badge bg-success me-1 mb-1">
                                                شماره صورتحساب {inv}
                                            </span>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )} */}

                        {uploadResult.errors.length > 0 && (
                            <div
                                className="alert alert-danger mb-0"
                                style={{ whiteSpace: 'pre-line', maxHeight: '240px', overflowY: 'auto', fontSize: '0.875rem' }}
                            >
                                <div className="fw-bold mb-2">⚠️ موارد زیر صادر نشدند:</div>
                                {uploadResult.errors.join('\n')}
                            </div>
                        )}
                    </div>
                )}

                <div className="text-center mb-4">
                    <h5 className="fw-bold mb-3">آپلود فایل</h5>
                    <div
                        className="border rounded p-3 mb-3"
                        style={{
                            borderStyle: 'dashed !important',
                            borderWidth: '2px',
                            borderColor: '#dee2e6',
                            backgroundColor: '#f8f9fa',
                            cursor: 'pointer'
                        }}
                        onClick={() => fileInputRef.current?.click()}
                    >
                        <input
                            ref={fileInputRef}
                            type="file"
                            className="d-none"
                            accept=".xlsx,.xls"
                            onChange={handleFileChange}
                        />
                        {selectedFile ? (
                            <div className="text-center">
                                <p className="mb-1 fw-medium">{selectedFile.name}</p>
                            </div>
                        ) : (
                            <div className="text-muted">
                                <i className="feather-upload-cloud display-6 d-block mb-2"></i>
                                <p className="mb-0">فایل اکسل را انتخاب کنید</p>
                            </div>
                        )}
                    </div>

                    {selectedFile && (
                        <div className="border rounded p-2 mb-3 text-end" style={{ backgroundColor: '#f8f9fa' }}>
                            <small className="text-muted">
                                نام فایل: {selectedFile.name}<br />
                                حجم: {formatFileSize(selectedFile.size)}
                            </small>
                        </div>
                    )}
                </div>

                <div className="mb-3">
                    <label className="form-label text-end d-block">
                        نام شعبه : <span className="text-danger">*</span>
                    </label>
                    <select
                        className="form-select"
                        value={selectedBranch}
                        onChange={(e) => { setSelectedBranch(e.target.value); setUploadError(''); }}
                    >
                        {branches && branches.map((branch) => (
                            <option key={branch.id || branch.taxMemoryId} value={branch.taxMemoryId}>
                                {branch.name || branch.branchName || branch.taxMemoryId}
                            </option>
                        ))}
                    </select>
                </div>

                <button
                    className="btn btn-success w-100 py-2"
                    onClick={handleUpload}
                    disabled={isUploading || !selectedFile || !selectedBranch}
                >
                    {isUploading ? (
                        <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            در حال آپلود...
                        </>
                    ) : 'آپلود'}
                </button>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-danger" onClick={resetAndClose}>لغو</button>
            </Modal.Footer>
        </Modal>
    );
}

export default ExcelUploadModal;
